/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: '日付',
  time: '時間',
  hours: '{howMany}時間',
  minutes: '{howMany}分',
  today: '今日',
  duration: '期間',
  topic: '会議タイトル',
  voIPOnly: 'インターネット音声のみ',
  telephonyOnly: '電話のみ',
  both: '電話とインターネットの音声',
  thirdParty: 'サードパーティー製オーディオ',
  meetingId: '会議ID',
  password: 'パスワード',
  video: 'ビデオ',
  audio: '音声',
  scheduleFor: '次のユーザーに代わってスケジュールする',
  [ASSISTED_USERS_MYSELF]: '自分',
  meetingOptions: '会議オプション',
  meetingSettings: '会議設定',
  rcMeetingSettings: 'ビデオ会議の設定',
  audioOptions: '音声オプション',
  recurringMeeting: '定例会議',
  recurringNote: '注意：「反復」を選択する場合はこのオプションを有効にします',
  joinBeforeHost: 'ホストより早く参加者が参加することを許可する',
  turnOffCamera: '参加者のカメラをオフにする',
  turnOffHostCamera: '会議への参加時にホストのカメラをオフにする',
  requirePassword: 'パスワードが必要です',
  enterPassword: 'パスワードを入力',
  setPassword: 'パスワードを設定*',
  passwordEmptyError: '会議パスワードが必要です',
  rcmPasswordInvalidError: 'パスワードは1～10文字で英数字と@*-のみ使用できます',
  rcmPasswordHintText: 'パスワードは1～10文字で英数字と@*-のみ使用できます',
  usePersonalMeetingId: '個人会議IDを使用',
  pmiChangeConfirm: '個人会議に変更を加える場合は、 ',
  changePmiSettings: 'PMI設定を変更します',
  pmiSettingChangeAlert:
    '設定を変更してこの会議をスケジュールする場合は、個人会議IDのある会議すべてで同じ最新の設定が使用されます。',
  lockedTooltip: 'この設定は会社の管理者により管理されています',
  when: '日時',
  recurringDescribe:
    '出席者に対するカレンダーの招待で、会議が定期的に、または繰り返し設定されていることを確認してください。',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
